module.exports = __webpack_public_path__ + "img/2024-10-16a_1.506eaf99.jpg";